import React, { useContext, useEffect, useRef, useState } from 'react'
import { NavLink, useLocation, Link, useNavigate } from 'react-router-dom'
import {
  MdHome,
  MdBusiness,
  MdCategory,
  MdLanguage,
  MdLocationOn,
  MdLocationCity,
  MdGroup,
  MdFormatSize,
  MdAttachFile,
  MdPeople,
  MdKeyboardArrowDown,
  MdAccountBalanceWallet,
  MdAccessTime,
  MdGroupAdd,
  MdEventNote,
  MdDescription,
  MdBrandingWatermark,
  MdOutlineAssignmentTurnedIn,
  Md360,
  MdOutlineFestival,
  MdEventAvailable,
  MdOutlineLibraryAdd
} from 'react-icons/md'
import { GoNote } from "react-icons/go";
import { FaTasks, FaMoneyBillWave, FaList, FaGlobe } from 'react-icons/fa'
import { IoMdColorFill } from "react-icons/io";
import { getRole, removeRole, removeToken } from '../../utils/cookies/cookies'
import { IoIosBusiness } from 'react-icons/io'
import { TbAugmentedReality } from 'react-icons/tb'
import { AiOutlineLogout } from 'react-icons/ai'
import { usePermissions } from '../../context/permission'
import { ProfileContext } from '../../context/profile'
import { useSocket } from '../../context/socket'
import { TbView360Number } from "react-icons/tb";

const dataList = [
  {
    label: 'Dashboard',
    icon: <MdHome />,
    path: '/',
    permissionKey: null,
  },
  {
    label: 'Company Controllers',
    icon: <MdBusiness />,
    permissionKey: 'company_controllers',
    submenu: [
      { label: 'Type', path: '/companytype', icon: <MdBusiness /> },
      { label: 'Category', path: '/companycategory', icon: <MdCategory /> },
      { path: '/librarycategory', label: 'Library Category', icon: <MdCategory /> },
      { label: 'Size', path: '/size', icon: <MdFormatSize /> },
      { label: 'Material', path: '/material', icon: <MdAttachFile /> },
      { label: 'Color', path: '/color', icon: <IoMdColorFill /> },
      { label: 'Series', path: '/series', icon: <GoNote /> },
      { label: 'Country', path: '/country', icon: <MdLanguage /> },
      { label: 'State', path: '/state', icon: <MdLocationOn /> },
      { label: 'City', path: '/city', icon: <MdLocationCity /> },
    ],
  },
  {
    label: 'Master Controllers',
    icon: <MdBusiness />,
    permissionKey: 'master_controllers',
    submenu: [
      { label: 'Big Task Type', path: '/bigtasktype', icon: <MdBusiness /> },
      { label: 'Big Task Status', path: '/bigtaskstatus', icon: <MdCategory /> },

    ],
  },
  {
    label: 'Task Controllers',
    icon: <FaTasks />,
    permissionKey: 'task_controllers',
    submenu: [
      {
        label: 'Task Status',
        path: '/task-status',
        icon: <MdOutlineAssignmentTurnedIn />,
      },
    ],
  },
  {
    label: 'Roles',
    icon: <MdGroup />,
    path: '/roles',
    permissionKey: 'role',
  },
  {
    label: 'Marketing',
    icon: <MdLanguage />,
    permissionKey: 'marketing',
    submenu: [{ label: 'Wolfy Leads', path: '/leads', icon: <MdBusiness /> }],
  },
  {
    label: 'Accounting',
    icon: <MdAccountBalanceWallet />,
    path: '/accounting',
    permissionKey: 'accounting',
  },
  {
    label: 'Team',
    icon: <MdPeople />,
    permissionKey: 'team',
    submenu: [
      { label: 'Add Team', path: '/team', icon: <MdGroupAdd /> },
      { label: 'Attendance', path: '/attendance', icon: <MdAccessTime /> },
      { label: 'Leave', path: '/leave', icon: <MdEventNote /> },
      { label: 'Salary', path: '/salary', icon: <FaMoneyBillWave /> },
    ],
  },
  {
    label: 'Task',
    icon: <FaTasks />,
    path: '/task',
    permissionKey: 'task',
  },
  {
    label: 'Overdue Task',
    icon: <FaTasks />,
    path: '/overdue-task',
    permissionKey: 'overdue_task'
  },
  {
    path: '/company',
    label: 'Company',
    icon: <IoIosBusiness />,
    permissionKey: 'company',
  },
  {
    path: '/document',
    label: 'Document',
    icon: <MdDescription />,
    permissionKey: 'document',
  },
  {
    path: '/company-branding',
    label: 'Company Branding',
    icon: <MdBrandingWatermark />,
    permissionKey: 'company_branding',
  },

  // {path: '/social-media', label: 'Social Media', icon: <MdPostAdd />, permissionKey: 'social_media'},

  {
    path: '/360view',
    label: '360 View',
    icon: <Md360 />,
    permissionKey: 'view_360',
  },
  {
    path: '/arview',
    label: 'AR View',
    icon: <TbAugmentedReality />,
    permissionKey: 'ar',
  },
  { path: '/metaverse', label: 'Metaverse', icon: <FaGlobe />, permissionKey: 'metaverse' },
  {
    path: '/dynamic-360',
    label: 'Dynamic 360',
    icon: <TbView360Number />,
    permissionKey: 'dynamic_360',
  },
  {
    path: '/social-list',
    label: 'Social Media List',
    icon: <FaList />,
    permissionKey: 'socialList',
  },
  { path: '/festival-list', label: 'Festival List', icon: <MdOutlineFestival />, permissionKey: 'festival_list' },

  { path: '/festival', label: 'Festival/Event Approval', icon: <MdEventAvailable />, permissionKey: 'festival' },

  { path: '/library', label: 'Library', icon: <MdOutlineLibraryAdd />, permissionKey: 'library' }
]

const Sidebar = ({ sidebarOpen, setSidebarOpen }) => {
  const location = useLocation()
  const navigate = useNavigate()
  const socket = useSocket()

  const { getPermissions } = usePermissions()
  const { removeProfile } = useContext(ProfileContext)

  const { pathname } = location

  const trigger = useRef(null)
  const sidebar = useRef(null)

  const storedSidebarExpanded = localStorage.getItem('sidebar-expanded')
  const [sidebarExpanded, setSidebarExpanded] = useState(
    storedSidebarExpanded === null ? false : storedSidebarExpanded === 'true',
  )

  const [openSubmenu, setOpenSubmenu] = useState(null)
  const [currentRole, setCurrentRole] = useState('')
  const handleSubmenuToggle = (index) => {
    setOpenSubmenu((prev) => (prev === index ? null : index))
  }

  const filterSidebar = (role) => {
    switch (role) {
      case 'admin':
        return dataList

      case 'HR':
        return dataList.filter((item) => {
          return (
            item.label === 'Dashboard' ||
            item.label === 'Team' ||
            item.label === 'Task' ||
            item.label === 'Company' ||
            item.label === 'Document' ||
            item.label === '360 View' ||
            item.label === 'AR View' ||
            item.label === 'Metaverse' ||
            item.label === 'Social Media List' ||
            item.label === 'Festival List' ||
            item.label === 'Festival' ||
            item.label === 'Library' ||
            item.label === 'Library Category' ||
            item.label === 'Overdue Task'
          )
        })

      case 'Team Leader':
        return dataList.filter((item) => {
          return (
            item.label === 'Dashboard' ||
            item.label === 'Task' ||
            item.label === 'Overdue Task'
          )
        })

      case 'Social Media Coordinator':
        return dataList.filter((item) => {
          return (
            item.label === 'Dashboard' ||
            item.label === 'Task' ||
            item.label === 'Company Branding' ||
            item.label === 'Overdue Task'
          )
        })

      default: // For Staff
        return dataList.filter((item) => {
          return item.label === 'Dashboard' || item.label === 'Task'
        })
    }
  }

  // Filter the sidebar items based on user permissions
  // const filteredSidebar = dataList.filter(item => {
  //   if (!item.permissionKey) return true;

  //   return permissions[item.permissionKey]?.includes('View');
  // });

  useEffect(() => {
    setCurrentRole(getRole('user_role'))
  }, [])

  const handleLogout = () => {
    removeToken()
    removeRole()
    setTimeout(() => {
      navigate('/login')
    }, 100)
    removeProfile()
    if (socket) {
      socket.disconnect()
    }
  }

  const filteredSidebar = filterSidebar(currentRole)

  // Close sidebar when clicking outside
  useEffect(() => {
    const clickHandler = ({ target }) => {
      if (!sidebar.current || !trigger.current) return
      if (
        !sidebarOpen ||
        sidebar.current.contains(target) ||
        trigger.current.contains(target)
      )
        return
      setSidebarOpen(false)
    }
    document.addEventListener('click', clickHandler)
    return () => document.removeEventListener('click', clickHandler)
  })

  // Close sidebar on 'Escape' key press
  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (!sidebarOpen || keyCode !== 27) return
      setSidebarOpen(false)
    }
    document.addEventListener('keydown', keyHandler)
    return () => document.removeEventListener('keydown', keyHandler)
  })

  useEffect(() => {
    localStorage.setItem('sidebar-expanded', sidebarExpanded.toString())
    if (sidebarExpanded) {
      document.querySelector('body')?.classList.add('sidebar-expanded')
    } else {
      document.querySelector('body')?.classList.remove('sidebar-expanded')
    }
  }, [sidebarExpanded])

  return (
    <aside
      ref={sidebar}
      className={`absolute lg:static left-0 top-0 z-[9999] flex h-screen w-72 flex-col bg-white shadow-lg lg:translate-x-0 ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
    >
      <div className='flex items-center gap-3 px-4 py-4'>
        <div className='w-14 h-14 border border-orange-500 rounded-full flex items-center justify-center'>
          <img src='/WolfLogo.png' className='w-10 h-10' />
        </div>
        <NavLink to='/' className='text-xl font-medium text-black'>
          Wolfy
        </NavLink>
        <button
          ref={trigger}
          onClick={() => setSidebarOpen(!sidebarOpen)}
          aria-controls='sidebar'
          aria-expanded={sidebarOpen}
          className='hidden'
        ></button>
      </div>
      <div className='no-scrollbar flex flex-col overflow-y-auto duration-300 ease-linear'>
        <nav className='px-2'>
          <ul className='flex flex-col gap-1'>
            {filteredSidebar.map((item, index) => (
              <li key={index}>
                {item.submenu ? (
                  <div>
                    <NavLink
                      to={item.path}
                      onClick={() => handleSubmenuToggle(index)}
                      className={`group relative flex items-center gap-3 rounded-lg py-3 px-3 text-gray-700 hover:bg-orange-50 ${openSubmenu === index
                        ? 'bg-orange-50 border-l-4 border-l-orange-500'
                        : ''
                        }`}
                    >
                      {item.icon}
                      <span className='font-medium'>{item.label}</span>
                      <MdKeyboardArrowDown
                        className={`ml-auto transition-transform ${openSubmenu === index ? 'rotate-180' : ''
                          }`}
                      />
                    </NavLink>
                    {openSubmenu === index && (
                      <ul className='mt-1 ml-4 space-y-1'>
                        {item.submenu.map((submenuItem, subIndex) => (
                          <li key={subIndex}>
                            <NavLink
                              to={submenuItem.path}
                              className={`flex items-center gap-3 rounded-lg py-2 px-3 text-gray-700 hover:bg-orange-50 ${pathname === submenuItem.path
                                ? 'bg-orange-50 border-l-4 border-l-orange-500'
                                : ''
                                }`}
                            >
                              {submenuItem.icon}
                              <span className='font-medium'>
                                {submenuItem.label}
                              </span>
                            </NavLink>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                ) : (
                  <NavLink
                    to={item.path}
                    onClick={() => setSidebarOpen(!sidebarOpen)}
                    className={`flex items-center gap-3 rounded-lg py-3 px-3 text-gray-700 hover:bg-orange-50 ${pathname === item.path
                      ? 'bg-orange-50 border-l-4 border-l-orange-500'
                      : ''
                      }`}
                  >
                    {item.icon}
                    <span className='font-medium'>{item.label}</span>
                  </NavLink>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </div>
      <div className='mt-auto px-2 py-4 border-t border-gray-200'>
        {/* <NavLink
          to="/settings"
          className="flex items-center gap-3 border-b rounded-lg py-3 px-3 text-gray-700 hover:bg-orange-50"
        >
          <MdSettings />
          <span className="font-medium">Settings</span>
        </NavLink> */}
        <NavLink
          to='#'
          className='flex items-center gap-3 border-b rounded-lg py-3 px-3 text-gray-700 hover:bg-orange-50'
          onClick={handleLogout}
        >
          <AiOutlineLogout className='text-xl' />
          Logout
        </NavLink>
      </div>
    </aside>
  )
}

export default Sidebar
